module.exports = __webpack_public_path__ + "static/media/advisor-landing.1adaa2f1.png";